<template>
  <div class="show-notice">
    <div class="title-part">
      <h3>{{detail.msgTitle}}</h3>
      <span v-if="detail.msgType === 11">集采单位: </span><span v-if="detail.msgType === 11">{{detail.inviteType_dictText}}&ensp;&ensp;&ensp;&ensp;</span>
      <span>公告类型: </span><span style="color: #2D8CF0;">{{detail.msgType_dictText}}&ensp;&ensp;&ensp;&ensp;</span>
      <span>发布日期: </span><span>{{detail.publishTime}}</span>
    </div>
    <div class="content">
      <div v-html="detail.msgContent"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>

<style lang="less" scoped>
.title-part{
  width: 100%;
  text-align: center;
  h3{margin-bottom: .2rem;}
  padding-bottom: .1rem;
  border-bottom:1px solid #dddddd ;
}
.content{
  padding: .2rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/index.vue